import React, { useCallback } from 'react';
import { FlatList, StyleSheet } from 'react-native';
import { rem } from 'design-system';
import { useAppSelector } from 'store/hooks';
import SmartSecclAssetSummaryCard from './SmartSecclAssetSummaryCard';
const keyExtractor = (item) => item;
const SecclRecentlyViewedSection = ({ contentContainerStyle }) => {
    const selectedTradingAccountId = useAppSelector((state) => state.unpersistedInvestReducer.selectedTradingAccountId);
    const recentlyViewedAssetIds = useAppSelector((state) => selectedTradingAccountId
        ? state.invest.recentlyViewedAssetIdsForTradingAccount?.[selectedTradingAccountId]
        : undefined);
    const renderItem = useCallback(({ item }) => <SmartSecclAssetSummaryCard assetId={item}/>, []);
    if (!recentlyViewedAssetIds?.length) {
        return null;
    }
    return (<FlatList horizontal initialNumToRender={4} renderItem={renderItem} data={recentlyViewedAssetIds} keyExtractor={keyExtractor} style={styles.overflowVisible} keyboardShouldPersistTaps="handled" showsHorizontalScrollIndicator={false} contentContainerStyle={[styles.containerStyles, contentContainerStyle]}/>);
};
export default React.memo(SecclRecentlyViewedSection);
const styles = StyleSheet.create({
    containerStyles: {
        paddingHorizontal: rem(12),
    },
    overflowVisible: {
        overflow: 'visible',
    },
});
